namespace SP {
    export enum AuditReason {
        StockAudit = 0,
        ItemMissing = 1,
        ItemBroken = 2,
        DeliveryMiscount = 3,
        Other = 4
    }
}